import React from 'react';
import { useParams } from 'react-router-dom';
import DefaultLayout from '../../../layouts/default';
import { UserFormProvider } from '../context/UserFormContext';
import UserFormContent from '../components/UserFormContent';
export default function EditUserPage() {
  const { id } = useParams();
  return <DefaultLayout><UserFormProvider id={id} key={id}><UserFormContent /></UserFormProvider></DefaultLayout>;
}
